import React, { Component } from 'react';
import Button from 'components/Button/Button';
import { I18n } from 'react-i18next';
import i18n from '../../i18n';

export default class ButtonContainer extends Component {
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div className="btn-container mt15">
            <Button
              className={this.props.classButton1}
              to={this.props.linkButton1}
              delay={true}>
              {this.props.buttonText1}
            </Button>
            <a
              className={this.props.classButton2}
              href={this.props.linkButton2}
              target={
                this.props.linkButton2Target !== '_self' ? '_blank' : '_self'
              }
              rel="noopener noreferrer">
              {this.props.buttonText2}
            </a>
          </div>
        )}
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button-container.jsx